/**
 * 添加统一用登录态cookie函数
 * @param openid
 * @param openkey
 * @param sessionId
 * @param sessionType
 * @param wxAppid2
 * @param qqAppid
 * create by sevencai@20190410
 * contact seven.cailidan@gmail.com
 * 注意要添加 sessionCookie true 参数，用来保证设置的是 sessionCookie
 */

import cookies from "./cookies"

export default function setSessionCookie({ openid, openkey, sessionid, sessiontype, wxAppid2, qqAppid }) {
  cookies.set("midas_txcz_openid", openid, { sessionCookie: true })
  cookies.set("midas_txcz_openkey", openkey, { sessionCookie: true })
  cookies.set("midas_txcz_sessionid", sessionid, { sessionCookie: true })
  cookies.set("midas_txcz_sessiontype", sessiontype, { sessionCookie: true })

  if (wxAppid2) {
    cookies.set("midas_txcz_wxAppid2", wxAppid2, { sessionCookie: true })
  }

  if (qqAppid) {
    cookies.set("midas_txcz_qqAppid", qqAppid, { sessionCookie: true })
  }
}
